import React, { useEffect, useContext, useState } from "react";
import {
  View,
  StyleSheet,
  Image,
  TouchableOpacity,
  Dimensions,
  ImageSourcePropType} from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import Entypo from "@expo/vector-icons/Entypo";
import HomePage from "../screens/Home/HomePage";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { UserContext } from "../contexts/EmulateUserContext";
import { useNavigation } from "@react-navigation/native";
import { fonts } from "../styles/theme";
import AppText from "./AppText";
const { height } = Dimensions.get("window");

// Height of the header bar itself, excluding the status bar area above it.
// AppStackNavigator adds this to the top inset to offset the screen content.
export const HEADER_HEIGHT = 60;

const CustomHeader: React.FC = () => {
  const insets = useSafeAreaInsets();
  const { emulateUser, setEmulateUser } = useContext(UserContext);
  const [user, setUser] = useState<any>(null);
  const [userPicture, setUserPicture] = useState<ImageSourcePropType>();
  const [userInitials, setUserInitials] = useState<string | null>(null);
  const [homepageVisible, setHomepageVisible] = useState(false);
  const navigation = useNavigation();
  const handleBurgerPress = () => {
    setHomepageVisible(true);
  };

  const closeHomepage = () => {
    setHomepageVisible(false);
  };

  const handleDeEmulate = async () => {
    setEmulateUser(null);
    navigation.reset({
      index: 0,
      routes: [{ name: "Investments" }]});
    await AsyncStorage.setItem("apiResponse", JSON.stringify(user));
    AsyncStorage.removeItem("emulatedUser");
  };

  const getUser = async () => {
    try {
      const userInfo = await AsyncStorage.getItem("user");
      // console.log("the user in ...");
      if (userInfo !== null) {
        const user = JSON.parse(userInfo);
        setUser(user);

        // console.log("the userInfo is ", user);
      } else {
        // setUser(null);
      }
    } catch (error) {}
  };

  const getUserPic = async () => {
    try {
      const userInfo = await AsyncStorage.getItem("setUserProfile");
      const user = await AsyncStorage.getItem("user");
      const parsedUser = user ? JSON.parse(user) : null;

      if (userInfo === "local-defulat") {
        setUserPicture(require("../../assets/adaptive-iconh.png"));
      } else if (userInfo) {
        setUserPicture({ uri: userInfo });
      } else if (parsedUser && parsedUser.firstName && parsedUser.lastName) {
        const initials =
          parsedUser.firstName.charAt(0).toUpperCase() +
          parsedUser.lastName.charAt(0).toUpperCase();
        setUserInitials(initials); // you’ll create this state
        setUserPicture(undefined); // fallback to initials avatar
      }
    } catch (error) {
      console.error("Error retrieving user data:", error);
    }
  };
  useEffect(() => {
    getUser();
    getUserPic();
  }, []);
  useEffect(() => {}, [emulateUser]);

  return (
    <>
      <View
        style={[styles.headerContainer, { top: insets.top }]}
        testID="headerContainer"
      >
        <TouchableOpacity
          testID="burgerButton"
          onPress={handleBurgerPress}
          style={styles.burgerButton}
        >
          <MaterialIcons name="menu" size={28} style={styles.icon} />
        </TouchableOpacity>

        <View style={styles.userContainer}>
          {emulateUser ? (
            <>
              <TouchableOpacity
                onPress={handleDeEmulate}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center"}}
                testID="deEmulateButton"
              >
                <Entypo name="cross" size={24} color="#3629B7" />
                <AppText style={styles.userName}>
                  Emulating {emulateUser.fullName.split(" ")[0]}{" "}
                </AppText>
              </TouchableOpacity>
            </>
          ) : (
            <>
              {/* <AppText style={styles.userName}> {user?.name?.split(" ")[0]}</AppText> */}
              {/* <Image source={{ uri: user?.picture }} style={styles.avatar} /> */}
            </>
          )}

          {userPicture ? (
            <Image source={userPicture} style={styles.avatar} testID="avatar" />
          ) : (
            <View style={styles.initialsAvatar}>
              <AppText style={styles.initialsText}>{userInitials}</AppText>
            </View>
          )}
        </View>
      </View>

      {homepageVisible && (
        <>
          <TouchableOpacity
            onPress={closeHomepage}
            style={styles.overlay}
            testID="overlay"
          />
          <View
            style={[styles.overlayContent]}
            testID="overlayContent"
          >
            <HomePage closeHomepage={closeHomepage} />
          </View>
        </>
      )}
    </>
  );
};

export default CustomHeader;

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    height: HEADER_HEIGHT,
    paddingHorizontal: 15,
    backgroundColor: "#fff",
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    position: "absolute",
    // `top` is set inline from the measured safe-area inset.
    left: 0,
    right: 0,
    zIndex: 10},

  burgerButton: {
    padding: 10},

  icon: {
    width: 24,
    height: 24,
    tintColor: "#3629B7"},

  userContainer: {
    flexDirection: "row",
    alignItems: "center"},

  userName: {
    fontSize: 16,
    marginRight: 10,
    color: "#000",
    fontFamily: fonts.regular},

  emulatedUserName: {
    fontSize: 16,
    marginRight: 10,
    color: "#FF0000",
    flexDirection: "row",
    alignItems: "center",
    fontFamily: fonts.regular},

  cross: {
    fontSize: 16,
    color: "#FF0000",
    marginLeft: 5},

  avatar: {
    width: 30,
    height: 30,
    borderRadius: 20},

  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    position: "absolute",
    height: "100%",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 112},

  overlayContent: {
    position: "absolute",
    top: 0,
    bottom: 0,
    height: "100%",
    left: 0,
    right: 0,
    zIndex: 113,
    width: "65%",
    backgroundColor: "#fff"},
  initialsAvatar: {
    width: 30,
    height: 30,
    borderRadius: 20,
    backgroundColor: "#6C63FF",
    justifyContent: "center",
    alignItems: "center"},
  initialsText: {
    color: "#fff",

    fontSize: 14}});
